import { Url as UrlConnector } from "@web3-react/url";
import { BaseConnectorProps } from "./types";
import {
  useConnectEagerly,
  useConnector,
  useInitializeConnector,
  useSwitchChain,
} from "../hooks";
import { useCallback, useEffect } from "react";
import { Web3ConnectionType } from "../types";

export const Url = ({
  options,
  onStateUpdate,
  onConnectorUpdate,
  chainId,
}: BaseConnectorProps<UrlConnector>) => {
  const connector = useInitializeConnector(
    Web3ConnectionType.URL,
    useCallback(
      (actions) => {
        return new UrlConnector({
          actions,
          url: options.urls[options.defaultChainId][0],
        });
      },
      [options.defaultChainId, options.urls],
    ),
  );

  useEffect(() => {
    onConnectorUpdate(connector.connector);
  }, [connector.connector, onConnectorUpdate]);

  const state = useConnector(connector, onStateUpdate);

  useConnectEagerly(connector.connector, Web3ConnectionType.URL);

  useSwitchChain(connector.connector, state, chainId || options.defaultChainId);

  return null;
};
